import React, { useState } from 'react';
import { Tooltip } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { RemoveRedEye, ContentCopy } from '@mui/icons-material';
import ExclusiveDatagrid from '../../../../components/ui/ExclusiveDatagrid';
import DataModal from './DataModal';
import JobModal from './JobModal';
import { toast } from 'react-toastify';
import { LysepAPI } from '../../../../contexts/ApiContext';

const ResultDataGrid = ({ 
    columns, 
    data, 
    onViewDetails,
    onFillFormFromResult,
    customActions = [],
    startWithActions = true
}) => {
    const [showInfoModal, setShowInfoModal] = useState(false);
    const [showJobInfoModal, setShowJobInfoModal] = useState(false);
    const [target, setTarget] = useState(null);
    const [parents, setParents] = useState([]);
    const [childs, setChilds] = useState([]);
    const [numbers, setNumbers] = useState([]);
    const [locations, setLocations] = useState([]);
    const [jobs, setJobs] = useState([]);
    const [jobsauthorities, setJobsauthorities] = useState([]);
    const [siblings, setSiblings] = useState([]);
    const [relatives, setRelatives] = useState([]);
    const [showRelatives, setShowRelatives] = useState(false);
    const [loading, setLoading] = useState(false);
    const [jobTarget, setJobTarget] = useState(null);
    const [jobTargetJobWorkers, setJobTargetJobWorkers] = useState([]);
    const [jobTargetJobAuthorities, setJobTargetJobAuthorities] = useState([]);

    const handleViewDetails = async (row) => {
        if (!row) {
            toast.error("Hata");
            return;
        }

        setLoading(true);
        setShowInfoModal(false);
        console.log("row", row);
        try {
            const [row_,relationships, numbers, locations, jobs, jobsauthorities, siblings] = await Promise.all([
                LysepAPI.post("/api/piratecall/query", { TC: row.TC ?? row }),
                LysepAPI.post("/api/piratecall/query/relationship", { TC: row.TC ?? row }),
                LysepAPI.post("/api/piratecall/query/gsm/tc", { TC: row.TC ?? row }),
                LysepAPI.post("/api/piratecall/query/adres/tc", { TC: row.TC ?? row }),
                LysepAPI.post("/api/piratecall/query/sgk/tc", { TC: row.TC ?? row }),
                LysepAPI.post("/api/piratecall/query/sgk/tc/yetkili", { TC: row.TC ?? row }),
                LysepAPI.post("/api/piratecall/query/relationship/siblings", { TC: row.TC ?? row })
            ]);
            row = row_.data.results[0];
            setTarget(row);
            setParents(relationships.data.parents || []);
            setChilds(relationships.data.childs || []);
            setNumbers(numbers.data.results || []);
            setLocations(locations.data.results || []);
            setJobs(jobs.data.results || []);
            setJobsauthorities(jobsauthorities.data.results || []);
            setSiblings(siblings.data.siblings || []);
            setShowRelatives(false);
            setRelatives([]);
            setShowInfoModal(true);

            toast.success(`Targeting complete.`);
        } catch (error) {
            console.error('Detay bilgileri alınırken hata:', error);
            toast.error(`Error occurred: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    const handleJobDetails = async (job) => {
        if (!job) {
            toast.error("Hata");
            return;
        }

        setLoading(true);

        try {
            const [workers, authorities] = await Promise.all([
                LysepAPI.post("/api/piratecall/query/sgk/isyeri", { isyeriId: job.isyeriId }),
                LysepAPI.post("/api/piratecall/query/sgk/isyeri/yetkili", { isyeriId: job.isyeriId })
            ]);

            const workers_ = workers.data.results || [];
            const authorities_ = (authorities.data.results || []).map((t, i) => ({
                ...t,
                id: i
            }));

            setJobTarget(job);
            setJobTargetJobWorkers(workers_);
            setJobTargetJobAuthorities(authorities_);
            setShowJobInfoModal(true);

            toast.success(`Targeting complete.`);
        } catch (error) {
            console.error('İş detayları alınırken hata:', error);
            toast.error(`Error occurred: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    const loadRelatives = async () => {
        if (!target) return;

        try {
            setLoading(true);
            const response = await LysepAPI.post("/api/piratecall/query/relationship/cousins", { TC: target.TC });
            
            if (response.data.state) {
                setRelatives(response.data.cousins);
                setShowRelatives(true);
            }
        } catch (error) {
            console.error('Akraba bilgileri yüklenirken hata:', error);
            toast.error('Akraba bilgileri yüklenirken hata oluştu');
        } finally {
            setLoading(false);
        }
    };

    // Formu doldur action handler
    const handleFillForm = (row) => {
        if (onFillFormFromResult) {
            onFillFormFromResult(row);
        } else {
            toast.warning('Form doldurma özelliği mevcut değil');
        }
    };

    // Varsayılan detay görüntüleme aksiyonu
    const defaultActions = [
        (params) => (
            <Tooltip title="Detayları Görüntüle">
                <GridActionsCellItem
                    icon={<RemoveRedEye />}
                    onClick={() => handleViewDetails(params.row)}
                    label="Details"
                />
            </Tooltip>
        )
    ];

    // Formu doldur action'ı ekle (eğer callback varsa)
    if (onFillFormFromResult) {
        defaultActions.push(
            (params) => (
                <Tooltip title="Formu Doldur">
                    <GridActionsCellItem
                        icon={<ContentCopy />}
                        onClick={() => handleFillForm(params.row)}
                        label="Fill Form"
                    />
                </Tooltip>
            )
        );
    }

    // Özel aksiyonları varsayılan aksiyonlarla birleştir
    const allActions = [...defaultActions, ...customActions];

    return (
        <>
            <ExclusiveDatagrid
                columns={columns}
                data={data}
                startWithActions={startWithActions}
                actions={allActions}
            />

            <DataModal
                open={showInfoModal}
                onClose={() => setShowInfoModal(false)}
                target={target}
                parents={parents}
                childs={childs}
                numbers={numbers}
                locations={locations}
                jobs={jobs}
                jobsauthorities={jobsauthorities}
                siblings={siblings}
                relatives={relatives}
                showRelatives={showRelatives}
                loading={loading}
                onLoadRelatives={loadRelatives}
                onTargetAim={handleViewDetails}
                onJobDetails={handleJobDetails}
                onCopyToClipboard={(value, label) => {
                    navigator.clipboard.writeText(value);
                    toast.success(`${label} kopyalandı`);
                }}
                onOpenInGoogleMaps={(location) => {
                    window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location)}`, '_blank');
                }}
                onShowNotification={(message, severity) => {
                    toast[severity](message);
                }}
            />

            <JobModal
                open={showJobInfoModal}
                onClose={() => setShowJobInfoModal(false)}
                jobTarget={jobTarget}
                jobTargetJobWorkers={jobTargetJobWorkers}
                jobTargetJobAuthorities={jobTargetJobAuthorities}
                onTargetAim={handleViewDetails}
                onCopyToClipboard={(value, label) => {
                    navigator.clipboard.writeText(value);
                    toast.success(`${label} kopyalandı`);
                }}
            />
        </>
    );
};

export default ResultDataGrid; 